import { Component, forwardRef, Input, ChangeDetectionStrategy } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { InputBase } from '../input-base/input-base';

const INPUT_SWITCH_VALUE_ACCESSOR = {
	provide: NG_VALUE_ACCESSOR,
	// eslint-disable-next-line no-use-before-define, @typescript-eslint/no-use-before-define
	useExisting: forwardRef(() => InputSwitchComponent),
	multi: true,
};

@Component({
	selector: 'app-input-switch',
	templateUrl: './input-switch.component.html',
	styleUrls: ['../input-base/input-styles.scss', './input-switch.component.scss'],
	providers: [INPUT_SWITCH_VALUE_ACCESSOR],
	changeDetection: ChangeDetectionStrategy.Eager,
	standalone: false,
})
export class InputSwitchComponent extends InputBase implements ControlValueAccessor {
	@Input() labelPosition: 'before' | 'top' | 'after' = 'top';
}
